import FdnNotification from "@fdn/notification";
import FdnNotificationContainer from "@fdn/notification_container";

export const Mobile = (props) => (
	<FdnNotificationContainer
		id="group-notification"
		width="100%"
		top="0"
		right="0"
		left="0"
		padding="16px 16px 0 16px"
	>
		<>
			{props.data.map(({
				id, notifId, title, type, buttonText, url, body, ...notif
			}) => (
				<FdnNotification
					isMobile
					id={id}
					key={`${id}-mobile`}
					title={title}
					type={type}
					width="auto"
					onClose={props.onClose}
					duration={3000}
					closeable
					buttonText={buttonText || ""}
					cta={() => props.seenNotif({ ...notif, notifId, url }) || ""}
					body={body || ""}
				/>
			))}
		</>
		<style>
			{`
				#notification-container-group-notification.notification__container {
					box-sizing: border-box;
				}

				.notification__learn-more-button {
						border:none !important;
						background:none;
				}
			`}
		</style>
	</FdnNotificationContainer>
);
